export default {
    methods: {
        familyUrl (id) {
            return this.$router.resolve({
                name: 'family-card',
                params: { id }
            });
        },
        warehouseUrl (id) {
            return this.$router.resolve({
                name: 'warehouse-card',
                params: { id }
            });
        }
    }
};
